@if (showStepTracker()) {
  <div class="td-wb-step-tracker">
    @if (type() === 'percentage') {
      <div class="td-wb-step-tracker__percentage-bar">
        <div class="td-wb-step-tracker__percentage-bar-fill"
             [style.--value]="percentage()"></div>
      </div>
    } @else {
      <ol class="td-wb-step-tracker__segments"
          aria-hidden="true">
        @for (step of (steps() ?? []); track step; let i = $index) {
          <li class="td-wb-step-tracker__segment"
              [class.td-wb-step-tracker__segment--complete] = "i < currentStep()"
              [class.td-wb-step-tracker__segment--current] = "i === currentStep() && type() === 'indeterminate'">
            @if(type() === 'determinate' && i === currentStep()) {
              <div class="td-wb-step-tracker__percentage-bar-fill"
                   [style.--value]="percentage()"></div>
            }
          </li>
        }
      </ol>
    }
    @if (currentStep() < steps().length) {
      <div class="td-wb-step-tracker__header">
        <div>
          @if (editable()) {
            <div class="td-wb-step-tracker__small-text"
                 [innerText]="'tdWb.stepTracker.CHOOSE_A_STEP' | tdWbTranslate"></div>
            <a [tdWbOverlayToggle]="overlayTemplate"
               role="button"
               class="td-wb-step-tracker__editable-link"
               tdWbOverlayPosition="start-bottom"
               tdWbOverlaySize="small">
              @if (type() === 'percentage') {
                <span class="td-wb-step-tracker__heading-counter">
                  <span [innerText]="'tdWb.stepTracker.COMPLETED' | tdWbTranslate : { percentage: percentage() }"></span>
                </span>
              } @else {
                <span class="td-wb-step-tracker__heading-counter">
                  <span [innerText]="'tdWb.stepTracker.STEP_OF' | tdWbTranslate : { currentStep: currentStepNumber(), totalSteps: stepTotal() }"></span>
                  <hr class="td-wb-step-tracker__dash">
                  <span class="td-wb-step-tracker__heading-text"
                        [innerText]="stepLabel() | tdWbTranslate"></span>
                </span>
              }
              <td-wb-icon iconId="caret--down"
                          iconType="primary"
                          size="16" />
            </a>
          } @else {
            @if (type() === 'percentage') {
              <span class="td-wb-step-tracker__heading-counter">
                <span [innerText]="'tdWb.stepTracker.COMPLETED' | tdWbTranslate : { percentage: percentage() }"></span>
              </span>
            } @else {
              <span class="td-wb-step-tracker__heading-counter">
                <span [innerText]="'tdWb.stepTracker.STEP_OF' | tdWbTranslate : { currentStep: currentStepNumber(), totalSteps: stepTotal() }"></span>
                <hr class="td-wb-step-tracker__dash">
                <span class="td-wb-step-tracker__heading-text"
                      [innerText]="stepLabel() | tdWbTranslate"></span>
              </span>
            }
          }
        </div>
        <!-- Optional area for consumers to add functionality to the right -->
        <ng-content select=".td-wb-step-tracker__heading--right" />
      </div>
    }
  </div>
}

<ng-template #overlayTemplate>
  <td-wb-overlay aria-labelledby="overlay-title">
    <td-wb-overlay-header id="overlay-title">
      <span class="td-wb-step-tracker__overlay-text--bold"
            [innerText]="'tdWb.stepTracker.CHOOSE_A_STEP' | tdWbTranslate"></span>
    </td-wb-overlay-header>
    <td-wb-divider class="td-wb-step-tracker__overlay-divider" />
    <div>
      @for (step of (steps() ?? []); track step; let i = $index) {
        <div class="td-wb-step-tracker__overlay-step">
          <td-wb-icon iconId="tick"
                      class="td-wb-step-tracker__overlay-tick"
                      [iconType]="getIconType(i)"
                      size="16x18" />
          @if (i < currentStep()) {
            <a role="button"
               class="td-wb-step-tracker__overlay-link"
               tabindex="0"
               (click)="stepSelected(i)"
               (keydown.space)="stepSelected(i)"
               [id]="'td-wb-step-tracker-overlay-link-' + i"
               [attr.aria-labelledby]="'td-wb-step-tracker-overlay-link-text' + i">
              <span [id]="'td-wb-step-tracker-overlay-link-text' + i"
                    class="td-wb-step-tracker__overlay-text--link"
                    [innerText]="getSpecificStepText(i) | tdWbTranslate"></span>
              <td-wb-icon iconId="chevron-navigate"
                          iconType="primary" />
            </a>
          } @else if (i === currentStep()) {
            <span class="td-wb-step-tracker__overlay-text--bold"
                  [innerText]="getSpecificStepText(i) | tdWbTranslate"></span>
          } @else {
            <span class="td-wb-step-tracker__overlay-text"
                  [innerText]="getSpecificStepText(i) | tdWbTranslate"></span>
          }
        </div>
      }
    </div>
  </td-wb-overlay>
</ng-template>
